import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import CalculatorRoutes from '@/modules/calculator/routes';
import UsersRoutes from '@/modules/login/routes';
import AccountRoutes from '@/modules/account/routes';
import FinModelsRoutes from '@/modules/fin-models/routes';
import store from '../store';
import { v4 as uuidv4 } from 'uuid';
import {STORE_QUERY_PARAMS} from "@/router/constants";
import {setCookie} from "@/shared/utils";
import {config} from '@/config/config'
import LandingPageRoutes from '../modules/landing-pages/routes';

Vue.use(VueRouter);

// get
function getQueryParams() {
    var query = {}, queryString=window.location.search;
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}

let URLQuery = getQueryParams();
function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

STORE_QUERY_PARAMS.forEach((queryParam)=>{
    if(URLQuery[queryParam]){
        setCookie(queryParam, URLQuery[queryParam], {
            days: 72,
            domain: config('COOKIE_DOMAIN')
        });
    }
});

let routes = [
    {
        path: '/plans',
        name: 'upgrade',
        component: () => import('../modules/PlansExample'),
        children: []
    }
];


let extraRoutes = [CalculatorRoutes, UsersRoutes, AccountRoutes, FinModelsRoutes, LandingPageRoutes];

for (let r of extraRoutes) {
    routes = routes.concat(r);
}


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

(async () => {
    let landingPagesRoutes = ['homepage', 'plans', 'methodology', 'blog',
        'users_signup', 'users_signup_investor', 'users_forget_password', 'tos', 'privacy',
        'users_set_password', 'users_google_login', 'users_fb_login',
        'users_verify_email', 'users_login', 'blog_full', 'shared_reports', 'view_shared_report'];

    await store.dispatch('updateUserData')

    let activePage = router.history && router.history.pending && router.history.pending.name || router.history && router.history.current && router.history.current.name;
    if (!store.state.user.isLoggedIn && !landingPagesRoutes.includes(activePage)) {
        router.push({name: 'users_login'})
    }

    if(store.state.user.isLoggedIn){
        await SFAnalytics.identify(store.state.user.info.user.id, store.state.user.info.user);
    }
    else {
        await SFAnalytics.identify(uuidv4().slice(0,8), store.state.user.info.user);
    }

    if (activePage) {
        SFAnalytics.page(activePage);
        setTimeout(function (){
            window.Intercom? window.Intercom("update", {
                _p: (new Date()).getTime()
            }): null;
        }, 2000)
    }

    router.beforeEach(async (to, from, next) => {
        if (!landingPagesRoutes.includes(to.name)) {
            document.title = 'Startup Falcon - Put your Startup on the Scale';
        }

        if (!store.state.user.isLoggedIn && !landingPagesRoutes.includes(to.name)) {
            await store.dispatch('updateUserData')
        }

        if (store.state.user.isLoggedIn && !store.state.user.info.has_profile && !['startup-profile', 'investor-profile', 'onboarding', 'users_signup', 'user-type', 'checkout'].concat(landingPagesRoutes).includes(to.name)) {
            await router.push({name: 'user-type'})
        }


        if (store.state.user.isLoggedIn) {
            setTimeout(async () => {
                await store.dispatch('updateUserData')
            }, 100);
        }


        if (!store.state.user.isLoggedIn && !landingPagesRoutes.includes(to.name)) {
            next({name: 'users_login'})
        } else {
            next();
        }

        // SFAnalytics.page(to.name);
    });

    router.afterEach((to, from) => {
        setTimeout(function () {
            SFAnalytics.page(to.name);
        }, 500);
        setTimeout(function () {
            if(window.Intercom){
                window.Intercom("update", {
                    _p: (new Date()).getTime()
                })
            }
        }, 3000);
    })
})()


export default router;
